import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'motor-calculo-password-instructions',
  templateUrl: './password-instructions.component.html',
  styleUrls: ['./password-instructions.component.scss']
})
export class PasswordInstructionsComponent {
  @Input({ required: true }) passwordControl: FormControl<string | null>;
  @Input() classesCointainer: string;

  get passwordIsDirtyAndTouched(): boolean {
    return this.passwordControl.dirty && this.passwordControl.touched && this.passwordControl.value !== '';
  }
}
